/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';

import { N0, N20, N40A, N50A } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const PanelContent = styled.div``;

/**
 * `Worked on` component has a sub heading below main title so it will have
 * * `hasSubInfo = true`. `hasSubInfo` impacts bottom margin of the main title.
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const PanelContentHeader = styled.div<{ hasSubInfo?: boolean }>`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	margin-bottom: ${(props) =>
		props.hasSubInfo ? token('space.050', '4px') : token('space.200', '16px')};
	/* allow to freely style Add Link button and do not affect size of the Add link button */
	position: relative;
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const PanelContentTitle = styled.h2`
	font: ${token('font.heading.small')};
	margin-top: 0;
	word-break: 'break-all';
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const PanelContentWrapper = styled.div`
	background: ${token('color.background.neutral', N20)};
	border-radius: ${token('border.radius.100', '3px')};
	padding: ${token('space.100', '8px')};
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const PanelContentBody = styled.div`
	background: ${token('elevation.surface.raised', N0)};
	border-radius: ${token('border.radius.100', '3px')};
	box-shadow: ${token('elevation.shadow.raised', `0 1px 1px ${N50A}, 0 0 1px 1px ${N40A}`)};
	padding-top: ${token('space.200', '16px')};
	padding-bottom: ${token('space.200', '16px')};
	padding-left: ${token('space.075', '6px')};
	padding-right: ${token('space.075', '6px')};
`;
